import { ModuleConfig } from '@/core/module';
import { loanProductSettingsRoutes } from './routes';

export const LoanProductSettingsModule: ModuleConfig = {
    name: 'loan-product-settings',
    routes: loanProductSettingsRoutes,
    initialize: () => {
        console.log('Loan Product Settings module initialized');
    }
};
